var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.063 5.041H1.146a.917.917 0 00-.917.917V16.04c0 .506.41.917.917.917h11.917c.506 0 .916-.41.916-.917V5.958a.917.917 0 00-.916-.917zM21.553 5.568a.458.458 0 00-.446-.02l-5.5 2.75a.459.459 0 00-.253.41v4.583a.458.458 0 00.253.41l5.5 2.75a.46.46 0 00.664-.41V5.958a.459.459 0 00-.218-.39z",
    fill: "currentColor"
  })));
}

export default SvgCameraIcon;